export default __webpack_public_path__ + "static/media/hms-5.f5f6be90.jpg";